<template>
  <div class="box">
    <van-row class="seach">
      <van-col class="seach-item" span="12" @click="check('year')">{{seach.year || '年份'}}<img src="@/assets/images/xl.png"></van-col>
      <van-col class="seach-item" span="12" @click="check('month')">{{seach.month || '月份'}}<img src="@/assets/images/xl.png"></van-col>
    </van-row>
    <van-row class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="GetList">
          <van-cell v-for="(item, index) in list" :key="index" class="list-box" @click="goInfo(item)">
            <van-row class="list-box-top" type="flex" justify="space-between">
              <van-col class="list-box-top-no">{{item.year + "年" + item.month + "月工资"}}</van-col>
            </van-row>
            <van-row class="list-box-info">
              <p><span>应发合计：</span>￥{{item.yfhj}}</p>
              <p><span>实发合计：</span>￥{{item.sfhj}}</p>
            </van-row>
            <div v-if="(info.flzxzg && item.index == 0) || (info.bzzg && item.index == 3)" class="list-box-sup">
              <van-button round @click.stop="Supervise(item.objectID)" type="primary" icon="info" size="small" plain hairline>督办</van-button>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </van-row>

    <van-popup v-model="show" position="bottom">
      <div v-if="popupType == 'year'">
        <van-picker title="请选择年份" show-toolbar :columns="Year" @confirm="checkData" @cancel="cancelDate" />
      </div>
      <div v-if="popupType == 'month'">
        <van-picker title="请选择月份" show-toolbar :columns="Month" @confirm="checkData" @cancel="cancelDate" />
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "WagesIndex_P",
    title: "工资查询",
    data () {
      return {
        seach: { month: "", year: "" },
        info: { user: { avatar: "", name: "" }, dept: "", bz: false },
        isLoading: false,
        loading: false,
        finished: false,
        page: 1,
        list: [],
        active: 0,
        show: false,
        popupType: "",
        currentDate: new Date(),
        Year: [],
        Month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      }
    },
    mounted () {
      document.getElementsByClassName("box")[0].setAttribute("style", "min-height:" + window.innerHeight + "px;background-color: #f5f5f5;");
      this.Ajax.Get("api/Select/GetOption/Year").then(res => {
        this.Year = res.data;
      })
    },
    methods: {
      GetList () {
        if (this.page == 1) {
          this.list = [];
        }
        this.loading = true;
        this.Ajax.Get("/api/Wages/GetMySimpleInfo/" + this.page, this.seach).then(res => {
          this.isLoading = false;
          if ((this.page) * 10 >= res.count) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.page++;
          this.loading = false;
          res.data.forEach(item => {
            this.list.push(item)
          });
        });
      },
      onRefresh () {
        this.page = 1;
        this.GetList();
      },
      check (type) {
        this.popupType = type;
        this.show = true;
      },
      checkData (value) {
        switch (this.popupType) {
          default:
            this.seach[this.popupType] = value;
            break;
        }
        this.show = false;
        this.onRefresh();
      },
      cancelDate () {
        switch (this.popupType) {
          case "year":
            this.seach.year = ""
            break;
          case "month":
            this.seach.month = "";
            break;
        }
        this.show = false;
        this.onRefresh();
      },
      goInfo (obj) {
        this.$router.push({ name: "wagesInfo", params: { year: obj.year, month: obj.month } })
      },
    },
  }
</script>
<style scoped>
  .list {
    margin: 10px 15px 0 10px;
  }
  * >>> .van-cell {
    border-radius: 5px;
    padding-left: 0px;
  }
  .list-box-top {
    line-height: 25px;
  }
  .list-box-top-no {
    background-color: #3a92e2;
    color: #fff;
    padding-left: 20px;
    border-radius: 0 15px 15px 0;
    padding-right: 20px;
  }
  .list-box-info {
    font-size: 14px;
    line-height: 24px;
    color: #333;
    padding-left: 20px;
    text-align: right;
  }
  .list-box-sup {
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .list-box-info span {
    font-weight: bold;
    float: left;
  }
  .seach {
    font-size: 12px;
    padding: 10px;
    color: #999999;
    background-color: #fff;
  }
  .seach-item {
    padding: 5px 15px 5px 20px;
    border-right: 1px solid #dddddd;
  }
  .seach-item:last-child {
    border: none;
  }
  .seach-item img {
    width: 12px;
    float: right;
  }
</style>